import { useSocketService } from "../../../lib/hooks";
export var SocketService = function SocketService(_ref) {
  var children = _ref.children;
  useSocketService();
  return children;
};